import React, { useEffect, useState } from 'react';
import Loader from '@components/common/Loader/newLoaderModal';
import { APP_CONFIG, COUNTRY_CODE } from '@constants';
import { CUSTOM_MESSAGES, LABEL } from '../../veriables';
import ReceiptScreen from '@components/ReceiptScreen';
import PaymentScreen from '@components/PaymentScreens/paymentTerminalPaymentScreen';
import PaymentProcessScreen from '@components/PaymentScreens/paymentTerminalPaymentScreenProcess'
import Modal from '@components/common/Modal';
import cn from 'classnames';
import style from '@containers/ViewReceipt/viewreceipt.module.scss';
import {
  paymentInitialization, paymentCash, paymentAuth,
  paymentAuthError, paymentAuthComplete, receiptEmail,
  paymentSale,
  receiptSms, paymentSignature,
  setAuthResponse, receiptPrint, giftCardBalance,
  giftCardPaymentInit, giftCardPayments, textToPay,
  clearAuthResponse, ingenicoLog, ingenicoPayment,
  clearGiftCardBalanceInfo
} from '@reducers/payment';
import {
  updateChecksAfterResponse
} from '@reducers/storeChecks';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { setNotification, setPrintNotification, closePrintNotification } from '@reducers/notification';
import ReceiptScreenPopUp from '@components/checksCommon/receiptscreenPopUp';
import {
  removeSeat, removePaymentCheck, updateSeatInfo,
  setPaymentCheck, checkVoid
} from '@reducers/orders';
import EventEmitter from '@utility/eventSubscribers';
import { getObjectValue, urlSearchParams } from '@utility/utills';
import TipsConfirmPopUp from '@containers/ViewReceipt/tipsConfirmationPopUp';
import { submitSurvey, getSurvey } from '@reducers/survey';
import { flowType } from '@utility/userInfo';
import EmployeeCheck from '@components/checksCommon/employeeCheck';
import { openEmployeeCheck, setScreenSaverStatus } from '@reducers/oauth';
import CashPaymentCheckPopUp from '@containers/ViewReceipt/cashPaymentCheck';
import { callServer } from '@reducers/checks';
import NumberKeyboard from '@components/common/formElements/SimpleKeyboard/numberKeyboard';

const PaymentTerminalReceiptScreen = (props) => {
  const [tableData, setTableData] = useState(props.paymentCheck);
  const [isTipsConfirm, setIsTipsConfirm] = useState(false);
  const [selectedPayment, setSelectedPayment] = useState('');
  const [giftBalance, setGiftBalance] = useState(false);
  const [charityAmount, setCharityAmount] = useState(0);
  const skipSurvey = getObjectValue(() => (props.seat.sourceType === 6 || props.seat.sourceType === 7), false);
  const defaultCountryCode = getObjectValue(() => COUNTRY_CODE[props.auth.country].dialCode, '1');
  const isExternalCreditCard = defaultCountryCode === '44' && getObjectValue(() => props.deviceInfo.deviceGroup.paymentTypes.externalCreditCard, false);
  const [phoneNumberMaxLength, setPhoneNumberMaxLength] = useState(getObjectValue(() => COUNTRY_CODE[props.auth.country].maxLength, 15));
  const [confirmPopup, setConfirmPopup] = useState(false);
  const storeTips = props.auth.tipInfo ? props.auth.tipInfo.tips.map((item, index) => {
    return props.auth.tipInfo.ruleType === 1 ? {
      ...item,
      id: index + 1,
      key: item.value * 100,
      displayKey: `${item.value * 100} %`,
      ruleType: props.auth.tipInfo.ruleType
    } : {
      ...item,
      id: index + 1,
      key: item.value,
      displayKey: `${Number(item.value).toFixed(2)} ${LABEL().CURRENCY_SYMBOL}`,
      ruleType: props.auth.tipInfo.ruleType
    };
  }) : [];
  let charityList = props.auth.charity && props.auth.charity.enableFixedAmount ? [
    { id: 1, displayKey: `${LABEL().CURRENCY_SYMBOL}${props.auth.charity.fixedValue1}.00` },
    { id: 2, displayKey: `${LABEL().CURRENCY_SYMBOL}${props.auth.charity.fixedValue2}.00` },
    { id: 3, displayKey: `${LABEL().CURRENCY_SYMBOL}${props.auth.charity.fixedValue3}.00` },
  ] : [];
  charityList = props.auth.charity && props.auth.charity.enableRoundUp ? [
    ...charityList,
    { id: 4, displayKey: LABEL().ROUND_UP }
  ] : charityList;
  charityList = props.auth.charity && props.auth.charity.enableCustomAmount ? [
    ...charityList,
    { id: 4, displayKey: `${LABEL().CUSTOM} ${LABEL().CURRENCY_SYMBOL}` }
  ] : charityList;

  const supportsTips = getObjectValue(() => props.auth?.tipInfo && props.auth.tipInfo.tips?.length > 0, false);
  const tipsList = supportsTips ? [...storeTips, { id: 4, key: `Other ${LABEL().CURRENCY_SYMBOL}`, displayKey: `Other ${LABEL().CURRENCY_SYMBOL}` }, { id: 5, key: 'Other %', displayKey: 'Other %' }] : [];
  const [active, setActive] = useState('');
  const hideSignature = props.auth.serverAppFeatures.supportsNoSignatureOnPayment;
  const [paymentType, setPaymentType] = useState(Number(urlSearchParams('screenType')) || 1);
  const currenySymbol = LABEL().CURRENCY_SYMBOL;
  const [tipAmount, setTipAmount] = useState(0);
  const [paymentAmount, setPaymentAmount] = useState(Number(tableData.unpaidAmount).toFixed(2));
  const [isReceipt, setIsReceipt] = useState({});
  const [keyboardValue, setKeyboardValue] = useState('');
  const supportsSurvey = getObjectValue(() => props.auth.serverAppFeatures.supportsSurvey, false);
  const supportCashPayment = getObjectValue(() => props.auth.serverAppFeatures.supportsCashPayment, false);
  const selectedAnswers = JSON.parse(window.sessionStorage.getItem('selectedQuestions')) || [];
  const [isSwipe, setIsSwipe] = useState(false);
  const [giftCardNumber, setGiftCardNumber] = useState();
  const [textToPayModelOpen, setTextToPayModelOpen] = useState(false);
  const supportsWarnOnUnusualTip = getObjectValue(() => props.auth.tipInfo.warnIfTipUnusual, false);
  const [errorMessage, setErrorMessage] = useState('');
  const [countryCode, setCountryCode] = useState(defaultCountryCode);
  const [successMessage, setSuccesMessage] = useState('');
  const [isCashPaymentCheck, setIsCashPaymentCheck] = useState(false);
  const [confirmCashPayment, setConfirmCashPayment] = useState(false);
  const isServerApp = flowType() === 'serverApp';
  const isTableTop = flowType() === 'tableTop';
  const isKiosk = flowType() === 'kiosk';
  const isPaymentTerminal = flowType() === 'paymentTerminal';
  const isWalkUp = getObjectValue(() => props.seat && (props.seat.sourceType === 7), false);
  const isDefaultMode = getObjectValue(() => (!isWalkUp && (!props.deviceInfo.deviceGroup || [0].includes(props.deviceInfo.deviceGroup.startMode))), false);
  const isCounter = getObjectValue(() => isServerApp && [1].includes(props.deviceInfo.deviceGroup.startMode), false);
  const isDriveThru = getObjectValue(() => isServerApp && [3].includes(props.deviceInfo.deviceGroup.startMode), false);
  const isCallCenter = getObjectValue(() => isServerApp && [2].includes(props.deviceInfo.deviceGroup.startMode), false);
  const isOrderPayMode = getObjectValue(() => isTableTop && [1].includes(props.deviceInfo.deviceGroup.startMode), false);
  const [cancelOrderConfirm, setCancelOrderConfirm] = useState(false);
  const [hideCancelIcon, setHideCancelIcon] = useState(false);
  const [directToCashConfirm, setDirectToCashCOnfirmation] = useState(false);
  const isTipRequried = getObjectValue(() => props.auth.tipInfo.requireTipSelection, false);
  const receiptTypes = getObjectValue(() => props.deviceInfo.deviceGroup.receiptTypes, null);
  const [isConfirmSplit, setIsConfirmSplit] = useState(false);
  const [splitType, setSplitType] = useState();
  const [isCustomTipModelOpen, setCustomTipModelOpen] = useState(false);
  const [externalId, setExternalId] = useState(false);

  const handleBackButton = () => {
    let temp = { isShow: false, url: () => { } };
    const type = () => {
      switch (Number(urlSearchParams('ticketSplitTypeId'))) {
        case 1: return tableData.paymentStages.length === 0 ? '&type=cash' : '&type=stage';
        default: return '';
      }
    };
    if ([2, 9, 10, 12, 4, 16].includes(paymentType)) {
      switch (urlSearchParams('type')) {
        case 'stage': {
          temp = { isShow: true, url: () => props.history.replace(`${APP_CONFIG.BASE_URL}/stagepayment/${tableData.id}`) }; break;
        }
        case 'payType':
          if ([12, 4, 16].includes(paymentType)) {
            temp = { isShow: true, url: () => { setGiftBalance(0); window.sessionStorage.removeItem('tipAmt'); setTipAmount(0); setPaymentType(2); props.history.replace(`${APP_CONFIG.BASE_URL}/paymentTerminal/receipt/${tableData.id}?ticketSplitTypeId=${urlSearchParams('ticketSplitTypeId')}&splitValue=${urlSearchParams('splitValue')}&screenType=2&type=payType`); } }; break;
          } else {
            temp = { isShow: true, url: () => { if ((Number(urlSearchParams('ticketSplitTypeId')) === 3 || Number(urlSearchParams('ticketSplitTypeId')) === 2) && Number(urlSearchParams('screenType')) === 2) { setTableData(props.seat); props.setPaymentCheck(props.seat); setPaymentAmount(props.seat.unpaidAmount); } setPaymentType(1); props.history.replace(`${APP_CONFIG.BASE_URL}/paymentTerminal/receipt/${tableData.id}?ticketSplitTypeId=${(Number(urlSearchParams('ticketSplitTypeId')) === 3 || Number(urlSearchParams('ticketSplitTypeId')) === 2) ? 1 : urlSearchParams('ticketSplitTypeId')}&splitValue=1&screenType=1`); } }; break;
          }
        case 'cash': {
          temp = { isShow: true, url: () => { setPaymentType(1); props.history.replace(`${APP_CONFIG.BASE_URL}/paymentTerminal/receipt/${tableData.id}?ticketSplitTypeId=1&splitValue=1&screenType=1`); } }; break;
        }
        case 'payAnAmount':
        case 'split': {
          temp = { isShow: true, url: () => { setPaymentType(1); props.history.replace(`${APP_CONFIG.BASE_URL}/paymentTerminal/receipt/${tableData.id}?ticketSplitTypeId=1&splitValue=1&screenType=1`); } }; break;
        }
        case 'gift': {
          temp = { isShow: true, url: () => { setPaymentType(2); props.history.replace(`${APP_CONFIG.BASE_URL}/paymentTerminal/receipt/${tableData.id}?ticketSplitTypeId=${urlSearchParams('ticketSplitTypeId')}&splitValue=${urlSearchParams('splitValue')}&screenType=2${type()}`); } }; break;
        }
        default:
          break;
      }
    }
    return temp;
  };

  const getTotalAmountForTip = () => {
    let Amount = getObjectValue(() => tableData.subTotalAmount, 0);
    if (getObjectValue(() => props.auth.tipInfo.suggestedTipIncludesTax, false)) {
      Amount += tableData.taxAmount;
    }
    if (getObjectValue(() => props.auth.tipInfo.suggestedTipExcludesDiscount, false)) {
      Amount -= tableData.discountAmount;
    }
    if (externalId) {
      Amount += tableData.taxAmount;
    }
    return Amount;
  };

  const returnCustomMessageWithReplace = () => {
    let message = '';
    if (CUSTOM_MESSAGES().EXTERNAL_CREDIT_CARD.includes('subtotal')) {
      message = CUSTOM_MESSAGES().EXTERNAL_CREDIT_CARD.replace('subtotal', `${LABEL().CURRENCY_SYMBOL}${getTotalAmountForTip()}`);
    }
    if (CUSTOM_MESSAGES().EXTERNAL_CREDIT_CARD.includes('tips')) {
      message = message.replace('tips', `${LABEL().CURRENCY_SYMBOL}${Number(keyboardValue).toFixed(2)}`);
    }
    return message;
  };

  useEffect(() => {
    if ([4].includes(paymentType)) {
      const activeTip = getObjectValue(() => storeTips.find((item) => item.isDefault).key, '');
      setActive(activeTip);
      const totalAmount = getTotalAmountForTip();
      setTipAmount(props?.auth?.tipInfo?.ruleType === 1 ? ((totalAmount * activeTip) / 100).toFixed(2) : +(activeTip || 0).toFixed(2));
    }
  }, [paymentType]);

  useEffect(() => {
    if (urlSearchParams('unlock')) {
      setHideCancelIcon(false);
    }
    setPaymentType(Number(urlSearchParams('screenType')));
    setTableData({
      ...props.paymentCheck
    });
    setPaymentAmount(isTableTop ? props.seat.unpaidAmount : props.paymentCheck.unpaidAmount);
  }, [props.paymentCheck]);

  const SeatIds = () => {
    return tableData.seats.reduce((a, v) => {
      if (v.open) {
        a.push(v.id);
      }
      return a;
    }, []);
  };

  const handlePrint = () => {
    props.receiptPrint({
      deviceId: props.deviceInfo.deviceId,
      employeeId: Number(props.userInfo.id),
      storeId: props.deviceInfo.storeId,
      ticketId: props.authResponse.ticket.id,
    }).then((res) => {
      if (window.ReactNativeWebView) {
        EventEmitter.print(res);
      }
      props.setPrintNotification(res);
    }).catch((err) => {
      props.setNotification({
        type: 'danger',
        message: err.message
      });
    });
  };

  const handleTip = (item) => {
    const totalAmount = getTotalAmountForTip();
    setActive(item);
    if (getObjectValue(() => item === storeTips[0].key, false)) {
      const tipamt = props.auth.tipInfo.ruleType === 1 ? ((totalAmount * storeTips[0].key) / 100).toFixed(2) : +(storeTips[0].key).toFixed(2);
      const payAmt = (Number(tipamt) + Number(totalAmount)).toFixed(2);
      setTipAmount(tipamt);
      setPaymentAmount(payAmt);
    } else if (getObjectValue(() => item === storeTips[1].key, false)) {
      const tipamt = props.auth.tipInfo.ruleType === 1 ? ((totalAmount * storeTips[1].key) / 100).toFixed(2) : +(storeTips[1].key).toFixed(2);
      const payAmt = (Number(tipamt) + Number(totalAmount)).toFixed(2);
      setTipAmount(tipamt);
      setPaymentAmount(payAmt);
    } else if (getObjectValue(() => item === storeTips[2].key, false)) {
      const tipamt = props.auth.tipInfo.ruleType === 1 ? ((totalAmount * storeTips[2].key) / 100).toFixed(2) : +(storeTips[2].key).toFixed(2);
      const payAmt = (Number(tipamt) + Number(totalAmount)).toFixed(2);
      setTipAmount(tipamt);
      setPaymentAmount(payAmt);
    } else {
      setTipAmount('0.00');
      setPaymentAmount(Number(tableData.unpaidAmount).toFixed(2));
    }
    if (item === `Other ${LABEL().CURRENCY_SYMBOL}` || item === 'Other %') {
      setCustomTipModelOpen(true);
    }
  };
  const handleCustomButtonClick = (item, value) => {
    setActive(item);
    const totalAmount = getTotalAmountForTip();
    if (!externalId) {
      if (item === `Other ${LABEL().CURRENCY_SYMBOL}` && value && value.length > 0 && Number(value) > 0) {
        const tipamt = Number(value).toFixed(2);
        const payAmt = (Number(value) + Number(totalAmount)).toFixed(2);
        setTipAmount(tipamt);
        setPaymentAmount(payAmt);
      } else if (item === 'Other %' && value && value.length > 0 && Number(value) > 0) {
        const tipamt = ((totalAmount * Number(value)) / 100).toFixed(2);
        const payAmt = (Number(tipamt) + Number(totalAmount)).toFixed(2);
        setTipAmount(tipamt);
        setPaymentAmount(payAmt);
      }
      setCustomTipModelOpen(false);
    } else {
      const tipamt = Number(value).toFixed(2);
      const payAmt = (Number(value) + Number(totalAmount)).toFixed(2);
      setTipAmount(tipamt);
      setPaymentAmount(payAmt);
      setCustomTipModelOpen(false);
      setConfirmPopup(true);
    }
  };

  const charityAmountCal = () => {
    const cielValue = Math.ceil(tableData && (tableData.totalAmount - tableData.paidAmount + Number(tipAmount)).toFixed(2));
    const tableVal = (tableData && (tableData.totalAmount - tableData.paidAmount + Number(tipAmount)).toFixed(2));
    return (cielValue - tableVal).toFixed(2);
  };

  const handleCharity = (item, value) => {
    const charityKey = charityList.map((e) => e.displayKey);
    if (charityKey.includes(item) && item.includes('.00')) {
      setCharityAmount(Number(item.split(`${LABEL().CURRENCY_SYMBOL}`)[1]));
    } else if (charityKey.includes(item) && item.includes(LABEL().ROUND_UP)) {
      setCharityAmount(charityAmountCal());
    } else if (charityKey.includes(item) && item.includes(LABEL().CUSTOM) && value && value.length > 0 && Number(value) > 0) {
      setCharityAmount(value);
    } else {
      setCharityAmount(0);
    }
  };

  const handleButtonClick = (item, value) => {
    setActive(item);
    switch (paymentType) {
      case 4: handleTip(item, value); break;
      case 13: handleCharity(item, value); break;
      default: break;
    }
  };
  const renderModifier = (modifiersObj) => (
    (modifiersObj || []).map((modifier) => (
      <div key={modifier.modifierId} className={modifier.price ? 'col-12 text-left p-0 fs-18' : 'd-none'}>
        {`${modifier.quantity > 1 ? `- ${modifier.quantity} x ` : '- '} ${modifier.modifierName} ${modifier.price ? `(${currenySymbol}${modifier.price.toFixed(2)})` : ''}`}
        {(modifier.note || modifier.comment) && <div className="pl-2">{modifier.note || modifier.comment}</div>}
        {modifier.modifiers && modifier.modifiers.length > 0 && (
          <div className="pl-2">
            {renderModifier(modifier.modifiers)}
          </div>
        )}
      </div>
    ))
  );

  const handleRoute = () => {
    setTipAmount(0);
    setKeyboardValue('');
    setActive('');
    setSuccesMessage('');
    window.sessionStorage.removeItem('accountNumber');
    const authResponse = getObjectValue(() => JSON.parse(window.sessionStorage.getItem('authResponse')), 0);
    const discount = getObjectValue(() => authResponse.checkHeader.discountAmount, 0);
    const serviceCharge = getObjectValue(() => authResponse.checkHeader.serviceChargeAmount, 0);
    const subtotalAmount = getObjectValue(() => authResponse.checkHeader.itemAmount, 0);
    const taxAmount = getObjectValue(() => authResponse.checkHeader.taxAmount, 0);
    const unpaidTips = getObjectValue(() => JSON.parse(window.sessionStorage.getItem('tipAmt')).unpaidTips, 0);
    const paidTips = getObjectValue(() => JSON.parse(window.sessionStorage.getItem('tipAmt')).paidTips, 0);
    if (urlSearchParams('ticketSplitTypeId') === '1') {
      if (urlSearchParams('type') === 'stage' && authResponse.checkHeader.paymentStages.filter((d) => d.status === 0).length > 0 && (Number(props.paymentCheck.stageData.totalAmount).toFixed(2) === Number(authResponse.ticket?.totalAmount).toFixed(2))) {
        props.updateSeatInfo(authResponse.checkHeader).then(() => {
          props.clearAuthResponse();
          props.history.replace(`${APP_CONFIG.BASE_URL}/stagepayment/${tableData.id}`);
        });
      } else if (urlSearchParams('type') === 'stage' && (Number(props.seat.totalAmount).toFixed(2) > Number(authResponse.ticket.totalTicketAmount).toFixed(2))) {
        props.setPaymentCheck({
          ...props.seat,
          unpaidTips,
          paidTips,
          paidAmount: props.paymentCheck.totalAmount
        });
        props.updateSeatInfo(authResponse.checkHeader).then(() => {
          props.clearAuthResponse();
          setPaymentType(2);
          props.history.replace({ pathname: `${APP_CONFIG.BASE_URL}/paymentTerminal/receipt/${authResponse.checkHeader.id}?ticketSplitTypeId=1&splitValue=1&screenType=2&type=stage` });
        });
      } else if (Number(authResponse.checkHeader.paidAmount) < Number(authResponse.checkHeader.totalAmount)) {
        props.setPaymentCheck({
          ...authResponse.checkHeader,
          subtotalAmount,
          unpaidTips,
          paidTips
        });
        props.updateSeatInfo({ ...authResponse.checkHeader }).then(() => {
          props.history.replace({ pathname: `${APP_CONFIG.BASE_URL}/paymentTerminal/receipt/${authResponse.checkHeader.id}?ticketSplitTypeId=1&splitValue=1&screenType=1` });
        });
      } else {
        window.sessionStorage.removeItem('tipAmt');
        window.sessionStorage.removeItem('payAmt');
        props.updateSeatInfo({ ...authResponse.checkHeader });
        props.history.replace(`${APP_CONFIG.BASE_URL}/${flowType()}/checks`);
      }
    } else if (urlSearchParams('ticketSplitTypeId') === '4') {
      props.history.replace(`${APP_CONFIG.BASE_URL}/${flowType()}/checks`);
    } else if (urlSearchParams('ticketSplitTypeId') === '2') {
      props.setPaymentCheck({
        ...authResponse.checkHeader,
        subtotalAmount,
        unpaidTips,
        paidTips,
        totalAmount: Number(subtotalAmount + taxAmount + serviceCharge - discount),
        paidAmount: authResponse.checkHeader.paidAmount
      });
      props.updateSeatInfo(authResponse.checkHeader).then(() => {
        if (Number(authResponse.checkHeader.paidAmount) < Number(authResponse.checkHeader.totalAmount)) {
          props.history.replace({ pathname: `${APP_CONFIG.BASE_URL}/paymentTerminal/receipt/${authResponse.checkHeader.id}?ticketSplitTypeId=2&splitValue=1&screenType=1` });
        } else {
          props.history.replace(`${APP_CONFIG.BASE_URL}/${flowType()}/checks`);
        }
      });
    } else if (urlSearchParams('ticketSplitTypeId') === '3') {
      props.setPaymentCheck({
        ...authResponse.checkHeader,
        subtotalAmount,
        unpaidTips,
        paidTips,
        totalAmount: Number(subtotalAmount + taxAmount + serviceCharge - discount),
        paidAmount: authResponse.checkHeader.paidAmount
      });
      props.updateSeatInfo(authResponse.checkHeader).then(() => {
        if (Number(authResponse.checkHeader.paidAmount) < Number(authResponse.checkHeader.totalAmount)) {
          props.history.replace({ pathname: `${APP_CONFIG.BASE_URL}/paymentTerminal/receipt/${authResponse.checkHeader.id}?ticketSplitTypeId=3&splitValue=${authResponse.checkHeader.tickets[0].splitValue}&screenType=1` });
        } else {
          props.history.replace(`${APP_CONFIG.BASE_URL}/${flowType()}/checks`);
        }
      });
    } else {
      props.history.replace(`${APP_CONFIG.BASE_URL}/${flowType()}/checks`);
    }
  };

  const submitSurveyResponse = (surveyDataItem) => {
    const authResponse = getObjectValue(() => JSON.parse(window.sessionStorage.getItem('authResponse')), 0);
    let surveyResponse = [];
    if (surveyDataItem.questions.length > 0) {
      surveyResponse = surveyDataItem.questions.map((data) => {
        return selectedAnswers && selectedAnswers.length > 0 && !selectedAnswers.some((selectedQuest) => selectedQuest.questionId === data.id) && { questionId: data.id, responseId: null };
      });
    }
    if (selectedAnswers.length === 0) {
      surveyResponse = surveyDataItem.questions.map((data) => {
        return { questionId: data.surveyQuestionId, responseId: null };
      });
    }
    const sendJson = {
      storeId: props.deviceInfo.storeId,
      ticketId: getObjectValue(() => authResponse.ticket.id, null),
      deviceId: props.deviceInfo.deviceId,
      employeeId: props.userInfo.id,
      checkHeaderId: tableData.id,
      surveyId: surveyDataItem.id,
      responses: [...selectedAnswers, ...surveyResponse.filter((e) => e)]
    };
    props.submitSurvey(JSON.stringify(sendJson)).then(() => {
      if (isPaymentTerminal) {
        setPaymentType(11);
      } else {
        setPaymentType(5);
      }
    }).catch((err) => {
      props.setNotification({
        type: 'danger',
        message: err.message
      });
      setPaymentType(5);
    });
  };

  const getItems = () => {
    const itemArray = [];
    props.seat.items.forEach((item) => {
      itemArray.push({
        quantity: item.quantity,
        menuItemId: item.menuItemId,
        modifiers: item.modifiers
      });
    });
    return itemArray;
  };

  const getSurveyResponse = () => {
    const orders = getItems();
    const dataToSend = {
      storeId: props.deviceInfo.storeId,
      deviceId: props.deviceInfo.deviceId,
      employeeId: props.userInfo.id,
      items: orders
    };
    props.getSurvey(dataToSend).then((val) => {
      submitSurveyResponse(val);
    }).catch(() => {
      setPaymentType(5);
    });
  };

  const handleCashPayment = () => {
    if (!externalId) {
      setTipAmount(0);
    }
    setHideCancelIcon(true);
    let dataToSend = {
      storeId: props.deviceInfo.storeId,
      deviceId: props.deviceInfo.deviceId,
      employeeId: props.userInfo.id,
      checkHeaderId: tableData.id,
      employeeCard: getObjectValue(() => JSON.parse(window.sessionStorage.getItem('userInfo')).employeeCard, null),
      ticketSplitTypeId: Number(urlSearchParams('ticketSplitTypeId')),
      splitValue: Number(urlSearchParams('splitValue')),
      paymentStageId: getObjectValue(() => props.paymentCheck.paymentStageId, null),
      subTotalAmount: tableData.subTotalAmount,
      taxAmount: tableData.taxAmount || 0.00,
      seatIds: SeatIds(),
      serviceChargeAmount: tableData.serviceChargeAmount || 0.00,
      discountAmount: tableData.discountAmount || 0.00,
      orderPay: isOrderPayMode,
      speedOrder: isCounter || isDriveThru || isCallCenter,
    };
    if (externalId) {
      dataToSend = { ...dataToSend, tipAmount, externalSale: true };
    }
    props.paymentCash(dataToSend, externalId).then((res) => {
      const discount = getObjectValue(() => res.checkHeader.discountAmount, 0);
      const serviceCharge = getObjectValue(() => res.checkHeader.serviceChargeAmount, 0);
      const updatedResponse = props.auth.country === 1 ? {
        ...props.paymentCheck,
        totalAmount: +(res.ticket.totalTicketAmount),
        unpaidAmount: +(res.checkHeader.itemAmount + res.checkHeader.taxAmount + serviceCharge - discount - res.checkHeader.paidAmount)
      } : {
        ...props.paymentCheck,
        totalAmount: +(res.ticket.totalTicketAmount),
        unpaidAmount: +(res.checkHeader.itemAmount + res.checkHeader.taxAmount + serviceCharge - discount - res.checkHeader.paidAmount)
      };
      props.setPaymentCheck({ ...updatedResponse });
      setConfirmCashPayment(false);
      props.setAuthResponse(res).then(() => {
        if (externalId) {
          setPaymentType(5);
          props.history.replace({ pathname: `${APP_CONFIG.BASE_URL}/${flowType()}/receipt/${props.paymentCheck.id}?ticketSplitTypeId=${urlSearchParams('ticketSplitTypeId')}&splitValue=${urlSearchParams('splitValue')}&screenType=5&type=${urlSearchParams('type')}` });
        } else if (directToCashConfirm) {
          setPaymentType(6);
          setHideCancelIcon(false);
          setDirectToCashCOnfirmation(false);
          setIsCashPaymentCheck(false);
        } else {
          setPaymentType(17);
          props.history.replace({ pathname: `${APP_CONFIG.BASE_URL}/${flowType()}/receipt/${props.paymentCheck.id}?ticketSplitTypeId=${urlSearchParams('ticketSplitTypeId')}&splitValue=${urlSearchParams('splitValue')}&screenType=17&type=${urlSearchParams('type')}` });
        }
      });
    }).catch((err) => {
      if (directToCashConfirm) {
        setHideCancelIcon(false);
        setDirectToCashCOnfirmation(false);
        setIsCashPaymentCheck(false);
      }
      props.setNotification({
        type: 'danger',
        message: err.message
      });
    });
  };

  const processSaleInit = (saleResponse) => {
    const Amount = +(saleResponse.ticket?.totalAmount * 100);
    const TipAmount = +(tipAmount * 100);
    const data = {
      type: 'processCreditSale',
      data: {
        merchantInvoiceId: saleResponse.ticket?.id.toString(),
        employeeId: saleResponse.checkHeader.employeeId.toString(),
        latitude: '0',
        longitude: '0',
        notes: '',
        referenceId: saleResponse.ticket?.id.toString() || saleResponse.ticket?.referenceId,
        amount: `${Number(Amount).toFixed()}`,
        tipAmount: `${Number(TipAmount).toFixed()}`
      },
    };
    props.paymentSignature({
      ticketId: saleResponse.ticket?.id,
    }).then(() => {
      setPaymentType(3);
      setHideCancelIcon(true);
      window.sessionStorage.setItem('processSaleData', JSON.stringify(data));
      EventEmitter.sendMessage(data, (res) => {
      }, (err) => {
        console.log(err);
      });
    }).catch((err) => {
      props.setNotification({
        type: 'danger',
        message: err.message
      });
    });
  };

  const handleProcessCreditError = (errMsg) => {
    const authResponse = getObjectValue(() => JSON.parse(window.sessionStorage.getItem('authResponse')), 0);
    const tipAmt = getObjectValue(() => Number(JSON.parse(window.sessionStorage.getItem('tipAmt')).unpaidTips).toFixed(2), 0);
    const dataToSend = {
      message: errMsg,
      storeId: props.deviceInfo.storeId,
      deviceId: props.deviceInfo.deviceId,
      employeeId: props.userInfo.id,
      checkHeaderId: tableData.id,
      ticketId: authResponse.ticket?.id,
      subtotalAmount: getObjectValue(() => authResponse.ticket?.subtotalAmount || authResponse.ticket?.subTotalAmount, 0),
      taxAmount: authResponse.ticket?.taxAmount,
      authAmount: 0,
      tipAmount: tipAmt,
      cardHolderName: null,
      redactedCardNumber: null,
      cardExpirationDate: null,
      cardType: null,
      uniqueCardIdentifier: null,
      transactionId: null,
      clientTransactionId: null,
      authorizationCode: null,
      paymentStageId: getObjectValue(() => props.paymentCheck.paymentStageId, null),
      employeeCard: null,
      isPreAuth: false,
      partialAuth: false,
      serviceChargeAmount: getObjectValue(() => authResponse.ticket?.serviceChargeAmount || authResponse.ticket?.serviceChargeAmount, 0),
      discountAmount: getObjectValue(() => authResponse.ticket?.discountAmount || authResponse.ticket?.discountAmount, 0),
    };
    setErrorMessage(errMsg);
    props.paymentAuthError(dataToSend).then(() => {
      if (isPaymentTerminal) {
        const ingenicoLogData = {
          source: 'ingenico',
          requestBody: window.sessionStorage.getItem('processSaleData'),
          responseBody: JSON.stringify(errMsg)
        };
        setPaymentType(8);
        try {
          props.ingenicoLog(ingenicoLogData).then(() => {
            window.sessionStorage.removeItem('processSaleData');
          }).catch(() => {
            window.sessionStorage.removeItem('processSaleData');
          });
        } catch (e) {
          console.log(e);
        }
      }
      if (isCounter || isDriveThru || isOrderPayMode || isCallCenter) {
        setCancelOrderConfirm(true);
      }
    });
  };

  const completeProcessSale = (response) => {
    const aAmt = (response.authorizedAmount / 100).toFixed(2);
    const authResponse = getObjectValue(() => JSON.parse(window.sessionStorage.getItem('authResponse')), 0);
    const tipAmt = getObjectValue(() => Number(JSON.parse(window.sessionStorage.getItem('tipAmt')).unpaidTips).toFixed(2), 0);
    const dataToSend = {
      ...response,
      message: '',
      storeId: props.deviceInfo.storeId,
      deviceId: props.deviceInfo.deviceId,
      employeeId: props.userInfo.id,
      checkHeaderId: tableData.id,
      ticketId: authResponse.ticket?.id,
      subtotalAmount: getObjectValue(() => authResponse.ticket?.subtotalAmount || authResponse.ticket?.subTotalAmount, 0),
      taxAmount: authResponse.ticket?.taxAmount,
      authAmount: aAmt,
      tipAmount: tipAmt,
      cardHolderName: response.cardholderName,
      redactedCardNumber: response.redactedCardNumber,
      cardExpirationDate: response.cardExpirationDate,
      cardType: response.cardType,
      uniqueCardIdentifier: response.uniqueCardIdentifier,
      transactionId: response.transactionId,
      clientTransactionId: response.clientTransactionId,
      authorizationCode: response.authCode,
      paymentStageId: getObjectValue(() => props.paymentCheck.paymentStageId, null),
      employeeCard: getObjectValue(() => JSON.parse(window.sessionStorage.getItem('userInfo')).employeeCard, null),
      isPreAuth: false,
      partialAuth: false,
      serviceChargeAmount: getObjectValue(() => authResponse.ticket?.serviceChargeAmount || authResponse.ticket?.serviceChargeAmount, 0),
      discountAmount: getObjectValue(() => authResponse.ticket?.discountAmount || authResponse.ticket?.discountAmount, 0),
      orderPay: isOrderPayMode,
      speedOrder: isCounter || isDriveThru || isCallCenter,
      name: window.sessionStorage.getItem('counterName') || null,
      phoneNumber: window.sessionStorage.getItem('counterPhone') || null,
    };
    props.paymentSale(dataToSend).then((res) => {
      window.sessionStorage.setItem('authResponse', JSON.stringify(res));
      window.sessionStorage.removeItem('counterName');
      window.sessionStorage.removeItem('counterPhone');
      window.sessionStorage.removeItem('counterCountry');
      setTipAmount(tipAmt);
      if (isServerApp) {
        const ingenicoLogData = {
          source: 'ingenico',
          requestBody: window.sessionStorage.getItem('processSaleData'),
          responseBody: JSON.stringify(response)
        };
        try {
          props.ingenicoLog(ingenicoLogData).then(() => {
            window.sessionStorage.removeItem('processSaleData');
          }).catch(() => {
            window.sessionStorage.removeItem('processSaleData');
          });
        } catch (e) {
          console.log(e);
        }
      }
      setPaymentAmount((Number(window.sessionStorage.getItem('payAmt'))).toFixed(2));
      window.sessionStorage.removeItem('tipAmt');
      window.sessionStorage.removeItem('payAmt');
      if (supportsSurvey && !skipSurvey) {
        getSurveyResponse();
      } else {
        setPaymentType(5);
      }
    }).catch((err) => {
      props.paymentAuthError({ ...dataToSend, message: err.message }).then(() => {
        setPaymentType(8);
      });
    });
  };

  const ingenicoIPP350Payment = (saleResponse) => {
    const Amount = +(saleResponse.ticket?.totalAmount * 100);
    const TipAmount = +(tipAmount * 100);
    const dataToSend = {
      storeId: props.deviceInfo.storeId,
      deviceId: props.deviceInfo.deviceId,
      checkHeaderId: tableData.id,
      ticketId: saleResponse.ticket?.id.toString(),
      totalAmount: +(Amount).toFixed(2),
      tipAmount: +(TipAmount).toFixed(2)
    };
    props.ingenicoPayment(dataToSend).then((response) => {
      completeProcessSale(response);
    }).catch((error) => {
      handleProcessCreditError(error.message);
    });
  };

  const handleCreditCard = () => {
    const payCheck = isTableTop ? JSON.parse(window.sessionStorage.getItem('paymentCheck')) : tableData;
    const subTotalAmount = Number(payCheck.subTotalAmount).toFixed(2);
    const taxAmount = Number(payCheck.taxAmount).toFixed(2);
    const dataToSend = {
      storeId: props.deviceInfo.storeId,
      deviceId: props.deviceInfo.deviceId,
      employeeId: props.userInfo.id,
      checkHeaderId: payCheck.id,
      ticketSplitTypeId: Number(urlSearchParams('ticketSplitTypeId')),
      splitValue: Number(urlSearchParams('splitValue')),
      paymentStageId: getObjectValue(() => props.paymentCheck.paymentStageId, null),
      subTotalAmount,
      taxAmount,
      totalAmount: Number(payCheck.totalAmount).toFixed(2),
      unpaidAmount: Number(payCheck.unpaidAmount).toFixed(2),
      seatIds: SeatIds(),
      employeeCard: getObjectValue(() => JSON.parse(window.sessionStorage.getItem('userInfo')).employeeCard, null),
      serviceChargeAmount: Number(payCheck.serviceChargeAmount).toFixed(2),
      discountAmount: Number(payCheck.discountAmount).toFixed(2),
      orderPay: isOrderPayMode,
      speedOrder: isCounter || isDriveThru || isCallCenter
    };
    props.paymentInitialization(dataToSend).then((val) => {
      props.setAuthResponse(val).then(() => {
        if (window.ReactNativeWebView && getObjectValue(() => props.auth.cardReaderType !== 3 && props.auth.cardReaderType !== 5 && props.auth.cardReaderType !== 6, false)) {
          EventEmitter.removeListeners('processPayment', () => { });
          EventEmitter.removeListeners('processCreditSale', () => { });
          processSaleInit(val);
        } else if (getObjectValue(() => props.auth.cardReaderType === 3 || props.auth.cardReaderType === 5 || props.auth.cardReaderType === 6, false)) {
          ingenicoIPP350Payment(val);
        }
      });
    }).catch((err) => {
      props.setNotification({
        type: 'danger',
        message: err.message
      });
    });
  };

  const printListener = (data) => {
    if (data.type === 'error') {
      props.setNotification({
        type: 'danger',
        message: data.message
      });
    } else {
      props.closePrintNotification();
      setPaymentType(6);
      setHideCancelIcon(false);
    }
  };
  useEffect(() => {
    if (window.ReactNativeWebView) {
      try {
        EventEmitter.printData((res) => {
          printListener(res);
        },
          (err) => {
            props.setNotification({
              type: 'danger',
              message: err
            });
          });
      } catch (e) {
        console.log('catch', e);
      }
    }
    props.setScreenSaverStatus(false);
  }, []);

  const getBtnName = () => {
    const value = Object.keys(getObjectValue(() => props.deviceInfo.deviceGroup.paymentTypes, [])).find((v) => props.deviceInfo.deviceGroup.paymentTypes[v]);
    switch (value) {
      case 'creditCard': return { key: 'creditCard' };
      case 'cash': return { key: 'cash' };
      case 'scanToPay': return { key: 'scanToPay' };
      default: return { key: 'card' };
    }
  };

  const paymentBtn = () => {
    let btnName = { key: 'creditCard' };
    if (getObjectValue(() => props.deviceInfo.deviceGroup.paymentTypes, false) && Object.keys(getObjectValue(() => props.deviceInfo.deviceGroup.paymentTypes, [])).filter((v) => props.deviceInfo.deviceGroup.paymentTypes[v]).length > 1) {
      btnName = { key: 'all' };
    } else if (getObjectValue(() => props.deviceInfo.deviceGroup.paymentTypes, false) && Object.keys(getObjectValue(() => props.deviceInfo.deviceGroup.paymentTypes, [])).filter((v) => props.deviceInfo.deviceGroup.paymentTypes[v]).length === 1) {
      btnName = getBtnName();
    }
    return btnName;
  };

  const handlePaymentInit = () => {
    setPaymentType(15);
    props.history.replace(({ pathname: `${APP_CONFIG.BASE_URL}/paymentTerminal/receipt/${props.paymentCheck.id}?ticketSplitTypeId=${urlSearchParams('ticketSplitTypeId')}&splitValue=${urlSearchParams('splitValue')}&screenType=15` }));
  };

  const returnCreditCardMethod = () => {
    return getObjectValue(() => props.auth.cardReaderType === 3 || props.auth.cardReaderType === 5 || props.auth.cardReaderType === 6, false) ? handlePaymentInit() : handleCreditCard();
  };

  const handleTipsRouteTo = (type) => {
    const selectedPaymentType = type || selectedPayment || paymentBtn().key;
    switch (selectedPaymentType) {
      case 'giftCard': {
        setPaymentType(12);
        props.history.replace({ pathname: `${APP_CONFIG.BASE_URL}/paymentTerminal/receipt/${props.paymentCheck.id}?ticketSplitTypeId=${urlSearchParams('ticketSplitTypeId')}&splitValue=${urlSearchParams('splitValue')}&screenType=12&type=${urlSearchParams('type')}` });
        break;
      }
      case 'creditCard': returnCreditCardMethod(); break;
      default: break;
    }
  };

  const applyDonation = () => {
  };

  const handleTipsSubmit = () => {
    setIsTipsConfirm(false);
    const tips = { totalTips: tipAmount, unpaidTips: tipAmount, paidTips: 0 };
    window.sessionStorage.setItem('tipAmt', JSON.stringify(tips));
    window.sessionStorage.setItem('payAmt', getObjectValue(() => Number(tipAmount) + Number(props.authResponse.checkHeader.taxAmount) + Number(props.authResponse.checkHeader.subTotalAmount), 0));
    handleTipsRouteTo();
  };

  const handleReceiptPopUpOpen = (type) => {
    setIsReceipt({ isOpen: true, type });
  };

  const handlePartialGiftPayment = () => {
    setPaymentType(6);
    setHideCancelIcon(false);
  };

  const handleReceipt = (data) => {
    const dataToSend = {
      ...data,
      storeId: props.deviceInfo.storeId,
      ticketId: props.authResponse.ticket?.id ? props.authResponse.ticket?.id : null,
      deviceId: props.deviceInfo.deviceId,
      employeeId: props.userInfo.id,
      emailAddress: data.email || '',
      countryCode,
      phoneNumber: data.phone || '',
      optIn: data.optIn,
      employeeCard: null,
      accountNumber: data.accountNumber || null,
    };
    if (isReceipt.type === 'email') {
      props.receiptEmail(dataToSend).then(() => {
        setPaymentType(6);
        setHideCancelIcon(false);
        setIsReceipt({ isOpen: false, type: '' });
      }).catch((err) => {
        setIsReceipt({ isOpen: false, type: '' });
        props.setNotification({
          type: 'danger',
          message: err.message
        });
      });
    } else {
      props.receiptSms(dataToSend).then(() => {
        setIsReceipt({ isOpen: false, type: '' });
        handlePartialGiftPayment();
      }).catch((err) => {
        props.setNotification({
          type: 'danger',
          message: err.message
        });
        setIsReceipt({ isOpen: false, type: '' });
      });
    }
  };

  const stopPopUp = () => {
    if (typeof (active) === 'string' && active?.includes('Other')) {
      setIsTipsConfirm(true);
    } else {
      handleTipsSubmit();
    }
  };

  const handleRetry = () => {
    setErrorMessage('');
    if (isPaymentTerminal && paymentBtn().key === 'creditCard' && getObjectValue(() => props.auth.cardReaderType === 3 || props.auth.cardReaderType === 5 || props.auth.cardReaderType === 6, false)) {
      setPaymentType(15);
      props.history.replace({ pathname: `${APP_CONFIG.BASE_URL}/paymentTerminal/receipt/${props.paymentCheck.id}?ticketSplitTypeId=${urlSearchParams('ticketSplitTypeId')}&splitValue=${urlSearchParams('splitValue')}&screenType=15&type=${urlSearchParams('type')}` });
    } else {
      setPaymentType(2);
      props.history.replace({ pathname: `${APP_CONFIG.BASE_URL}/paymentTerminal/receipt/${props.paymentCheck.id}?ticketSplitTypeId=${urlSearchParams('ticketSplitTypeId')}&splitValue=${urlSearchParams('splitValue')}&screenType=2&type=${urlSearchParams('type')}` });
    }
    setHideCancelIcon(false);
    setCancelOrderConfirm(false);
  };

  const validateTips = () => {
    if (supportsTips && [''].includes(active) && isTipRequried) {
      props.setNotification({
        type: 'danger',
        message: CUSTOM_MESSAGES().ENTER_TIP_MSG
      });
    } else if (supportsTips) {
      stopPopUp();
    } else {
      handleTipsRouteTo();
    }
  };

  const handleTextToPay = () => {
    const dataToSend = {
      latitude: '0',
      longitude: '0',
      deviceId: props.deviceInfo.deviceId,
      storeId: props.deviceInfo.storeId,
      checkHeaderId: tableData.id,
    };
    props.textToPay(dataToSend).then((res) => {
      props.setAuthResponse({ ...res, checkHeader: { ...res.checkHeader, paidAmount: res.checkHeader.totalAmount, unpaidAmount: 0 } }).then(() => {
        setSuccesMessage(`${LABEL().TEXT_TO_PAY} Sent`);
        setPaymentType(6);
        setHideCancelIcon(false);
      });
    }).catch((err) => {
      props.setNotification({
        type: 'danger',
        message: err.message
      });
    });
  };

  const routeToGiftCard = () => {
    const updatedData = {
      ...props.paymentCheck,
      unpaidTips: 0,
      paidTips: 0,
    };
    props.setPaymentCheck(updatedData).then(() => {
      props.history.replace(({ pathname: `${APP_CONFIG.BASE_URL}/paymentTerminal/receipt/${updatedData.id}?ticketSplitTypeId=${urlSearchParams('ticketSplitTypeId')}&splitValue=${urlSearchParams('splitValue')}&screenType=12&type=${urlSearchParams('type')}` }));
    });
  };

  const isTipsRequiredCheck = (type, check, count) => {
    const unpaidTips = getObjectValue(() => JSON.parse(window.sessionStorage.getItem('tipAmt')).unpaidTips, tipAmount);
    setSelectedPayment(type);
    setTipAmount(Number(unpaidTips).toFixed(2));
    if (isPaymentTerminal) {
      setPaymentType(4);
      props.history.replace({ pathname: `${APP_CONFIG.BASE_URL}/${flowType()}/receipt/${props.paymentCheck.id}?ticketSplitTypeId=${urlSearchParams('ticketSplitTypeId')}&splitValue=${urlSearchParams('splitValue')}&screenType=4&type=${urlSearchParams('type')}` });
    } else if (Number(unpaidTips).toFixed(2) > 0 || (hideSignature && !supportsTips)) {
      switch (type) {
        case 'giftCard': routeToGiftCard(); break;
        case 'creditCard': {
          const updatedData = check ? {
            ...check,
            unpaidTips: 0,
            paidTips: 0,
          } : {
            ...props.paymentCheck,
            unpaidTips: 0,
            paidTips: 0,
          };
          props.setPaymentCheck(updatedData).then(() => {
            returnCreditCardMethod();
          });
          break;
        }
        default: break;
      }
    } else {
      handleTipsRouteTo(type, count);
    }
  };

  const handleCallServer = () => {
    const station = props.auth.stations.find((item) => (item.number) === (tableData.stationName));
    const dataToSend = {
      deviceId: props.deviceInfo.deviceId,
      storeId: props.deviceInfo.storeId,
      stationId: (station?.id) || null,
      checkHeaderId: (tableData?.id) || null,
      message: 'CASH PAYMENT REQUEST',
    };
    props.callServer(dataToSend).then(() => {
      setIsCashPaymentCheck(false);
    }).catch((err) => {
      props.setNotification({
        type: 'danger',
        message: err.message
      });
    });
  };

  const cashPaymentCheck = (type) => {
    switch (type) {
      case 'employeeLogin': props.openEmployeeCheck(); break;
      case 'callServer': handleCallServer(); break;
      case 'otherOptions': setIsCashPaymentCheck(false); break;
      default:
        break;
    }
  };

  const allowCashPaymentWithLogin = () => {
    if ((props.userInfo.jobId && props.employeeJobHashTable[props.userInfo.jobId].allowCashWithoutLogin) || isCounter || isDriveThru || isWalkUp || isCallCenter) {
      setPaymentType(16);
      props.history.replace({ pathname: `${APP_CONFIG.BASE_URL}/paymentTerminal/receipt/${props.paymentCheck.id}?ticketSplitTypeId=${urlSearchParams('ticketSplitTypeId')}&splitValue=${urlSearchParams('splitValue')}&screenType=16&type=${urlSearchParams('type')}` });
    } else {
      setIsCashPaymentCheck(true);
    }
  };

  const QrPayRouteFrom = () => {
    setPaymentType(6);
    setSuccesMessage(CUSTOM_MESSAGES().QR_PAY_COMPLETED_INFO);
  };

  const handleQRpay = () => {
    props.setPaymentCheck({ ...props.paymentCheck }).then(() => {
      props.history.replace(({ pathname: `${APP_CONFIG.BASE_URL}/paymentTerminal/receipt/${props.paymentCheck.id}?ticketSplitTypeId=1&splitValue=1&screenType=14&type=qrScanPay` }));
    });
  };

  const handleRouteCheck = () => {
    if (urlSearchParams('type') === 'qrScanPay') {
      props.history.replace({ pathname: `${APP_CONFIG.BASE_URL}/${flowType()}/checks` });
    } else {
      handleRoute();
    }
  };
  const handleDrawerOpen = () => {
    if (!isCounter || !isDriveThru || !isCallCenter) {
      setPaymentType(5);
      props.history.replace({ pathname: `${APP_CONFIG.BASE_URL}/${flowType()}/receipt/${props.paymentCheck.id}?ticketSplitTypeId=${urlSearchParams('ticketSplitTypeId')}&splitValue=${urlSearchParams('splitValue')}&screenType=5&type=${urlSearchParams('type')}` });
    } else {
      setPaymentType(18);
      props.history.replace({ pathname: `${APP_CONFIG.BASE_URL}/${flowType()}/receipt/${props.paymentCheck.id}?ticketSplitTypeId=${urlSearchParams('ticketSplitTypeId')}&splitValue=${urlSearchParams('splitValue')}&screenType=18&type=${urlSearchParams('type')}` });
    }
  };

  const handleCheck = (type, data) => {
    switch (type) {
      case 'cash': allowCashPaymentWithLogin(data); break;
      case 'creditCard': isTipsRequiredCheck('creditCard'); break;
      case 'externalCreditCard': setExternalId(true); setKeyboardValue(''); setCustomTipModelOpen(true); setActive(`Other ${LABEL().CURRENCY_SYMBOL}`); break;
      case 'tips': validateTips(data); break;
      case 'giftCard': isTipsRequiredCheck('giftCard'); break;
      case 'receipt': handlePartialGiftPayment(); break;
      case 'textToPay': handleTextToPay(); break;
      case 'qrPay': handleQRpay(); break;
      case 'qrPayRoute': QrPayRouteFrom(); break;
      case 'counterCashPay': handleCashPayment(); break;
      case 'drawerOpen': handleDrawerOpen(); break;
      default:
        break;
    }
  };
  const handleDirectToCashConfirmation = () => {
    setDirectToCashCOnfirmation(true);
  };

  const paymentRoute = (key, updatedData, ticketSplitTypeId) => {
    switch (key) {
      case 'creditCard': isTipsRequiredCheck(paymentBtn().key, updatedData); break;
      case 'cash': handleCashPayment(); break;
      case 'scanToPay': break;
      case 'all': props.history.replace(({ pathname: `${APP_CONFIG.BASE_URL}/paymentTerminal/receipt/${updatedData.id}?ticketSplitTypeId=${ticketSplitTypeId}&splitValue=1&screenType=2` })); break;
      default: isTipsRequiredCheck(paymentBtn().key, updatedData); break;
    }
  };

  const handlePayAnAmount = (values) => {
    const amount = +(values.payAnAmount);
    const unpaidTips = tableData.unpaidTips || 0;
    const checkTotal = +(props.seat.itemAmount + tableData.taxAmount + tableData.serviceChargeAmount - tableData.discountAmount + unpaidTips);
    const tips = Number(unpaidTips).toFixed(2);
    const taxAmount = +((amount * props.seat.taxAmount) / checkTotal).toFixed(2);
    const serviceChargeAmount = props.seat.serviceChargeAmount > 0 ? +((amount * props.seat.serviceChargeAmount) / checkTotal).toFixed(2) : 0;
    const discountAmount = props.seat.discountAmount > 0 ? +((amount * props.seat.discountAmount) / checkTotal).toFixed(2) : 0;
    const subTotalAmount = props.auth.country === 1 ? +(amount - (taxAmount + serviceChargeAmount) + discountAmount - tips).toFixed(2) : props.paymentCheck.subTotalAmount;
    const ticketSplitTypeId = values.isPayFullCheck && values.isPayFullCheck ? 1 : 2;
    setTipAmount(tips);
    const updatedData = {
      ...props.seat,
      subTotalAmount,
      unpaidAmount: amount,
      taxAmount,
      paidAmount: 0,
      tipAmount: 0,
      totalAmount: +(subTotalAmount + taxAmount + serviceChargeAmount - discountAmount),
      serviceChargeAmount,
      discountAmount,
      unpaidTips: 0,
      paidTips: 0,
    };
    props.setPaymentCheck(updatedData).then(() => {
      if (isTableTop) {
        paymentRoute(paymentBtn().key, updatedData, ticketSplitTypeId);
      } else {
        props.history.replace(({ pathname: `${APP_CONFIG.BASE_URL}/paymentTerminal/receipt/${updatedData.id}?ticketSplitTypeId=${Number(urlSearchParams('ticketSplitTypeId')) === 3 ? 3 : ticketSplitTypeId}&splitValue=${urlSearchParams('splitValue')}&screenType=2&type=payType` }));
      }
    });
  };

  const onPayFullCheckHandler = () => {
    const unpaidTips = tableData.unpaidTips || 0;
    const discount = getObjectValue(() => props.paymentCheck.discountAmount, 0);
    const serviceCharge = getObjectValue(() => props.paymentCheck.serviceChargeAmount, 0);
    const subtotalAmount = getObjectValue(() => props.paymentCheck.itemAmount, 0);
    const taxAmount = getObjectValue(() => props.paymentCheck.taxAmount, 0);
    const paidAmount = getObjectValue(() => props.paymentCheck.paidAmount, 0);
    const amount = +(subtotalAmount + taxAmount + serviceCharge - discount - paidAmount + unpaidTips);
    if (amount > 0) {
      handlePayAnAmount({ payAnAmount: amount, isPayFullCheck: true });
    } else {
      const updatedData = {
        ...props.paymentCheck,
      };
      props.setPaymentCheck(updatedData).then(() => {
        if (props.seat.paidAmount === 0) {
          props.history.replace(({ pathname: `${APP_CONFIG.BASE_URL}/paymentTerminal/receipt/${updatedData.id}?ticketSplitTypeId=1&splitValue=1&screenType=2&type=cash` }));
        } else {
          props.history.replace(({ pathname: `${APP_CONFIG.BASE_URL}/paymentTerminal/receipt/${updatedData.id}?ticketSplitTypeId=1&splitValue=1&screenType=2&type=credit` }));
        }
      });
    }
  };

  const handleGiftCard = (data) => {
    const dataToSend = {
      accountNumber: data.cardNumber,
      securityCode: data.securityCode,
      deviceId: props.deviceInfo.deviceId,
      employeeId: Number(props.userInfo.id),
      storeId: props.deviceInfo.storeId,
      method: data.method
    };
    props.giftCardBalance(dataToSend).then((res) => {
      setGiftBalance(res.balanceAmount);
    }).catch((err) => {
      props.setNotification({
        type: 'danger',
        message: err.message
      });
    });
  };

  const giftCardPayment = (giftAmount) => {
    setHideCancelIcon(true);
    const checkTotal = Number(tableData.totalAmount) + Number(tipAmount);
    const calTipAmt = +((giftAmount * tipAmount) / checkTotal).toFixed(2);
    const taxAmount = +((giftAmount * tableData.taxAmount) / checkTotal).toFixed(2);
    const serviceChargeAmount = tableData.serviceChargeAmount > 0 ? +((giftAmount * tableData.serviceChargeAmount) / checkTotal).toFixed(2) : 0;
    const discountAmount = tableData.discountAmount > 0 ? +((giftAmount * tableData.discountAmount) / checkTotal).toFixed(2) : 0;
    const subTotalAmount = +(giftAmount - (taxAmount + calTipAmt + serviceChargeAmount) + discountAmount).toFixed(2);
    const updateCheck = {
      ...tableData,
      subTotalAmount,
      taxAmount,
      tipAmount: calTipAmt,
      totalAmount: subTotalAmount + taxAmount + serviceChargeAmount - discountAmount,
      serviceChargeAmount,
      discountAmount
    };
    const dataToSend = {
      storeId: props.deviceInfo.storeId,
      deviceId: props.deviceInfo.deviceId,
      employeeId: props.userInfo.id,
      checkHeaderId: tableData.id,
      employeeCard: null,
      ticketSplitTypeId: Number(urlSearchParams('ticketSplitTypeId')),
      splitValue: Number(urlSearchParams('splitValue')),
      paymentStageId: getObjectValue(() => props.paymentCheck.paymentStageId, null),
      subTotalAmount,
      taxAmount,
      tipAmount: calTipAmt,
      totalAmount: Number(tableData.totalAmount).toFixed(2),
      unpaidAmount: Number(tableData.unpaidAmount).toFixed(2),
      seatIds: SeatIds(),
      serviceChargeAmount,
      discountAmount,
      method: giftCardNumber ? 'swipe' : 'type',
      giftCardNumber: props.giftCard.accountNumber,
      securityCode: props.giftCard.securityCode,
      orderPay: isOrderPayMode,
      speedOrder: isCounter || isDriveThru || isCallCenter
    };
    setTipAmount(calTipAmt);
    props.setPaymentCheck(updateCheck).then(() => {
      props.giftCardPaymentInit(dataToSend).then((res) => {
        const dataToGiftCardPayment = {
          message: '',
          storeId: props.deviceInfo.storeId,
          deviceId: props.deviceInfo.deviceId,
          employeeId: props.userInfo.id,
          checkHeaderId: tableData.id,
          ticketId: res.ticket.id,
          subTotalAmount,
          taxAmount,
          tipAmount: calTipAmt,
          transactionId: res.ticket.transactionId,
          clientTransactionId: res.ticket.clientTransactionId,
          authorizationCode: res.ticket.authorizationCode,
          paymentStageId: getObjectValue(() => props.paymentCheck.paymentStageId, null),
          employeeCard: null,
          isPreAuth: false,
          partialAuth: false,
          serviceChargeAmount,
          discountAmount,
          method: giftCardNumber ? 'swipe' : 'type',
          giftCardNumber: props.giftCard.accountNumber,
          securityCode: props.giftCard.securityCode,
          orderPay: isOrderPayMode,
          speedOrder: isCounter || isDriveThru || isCallCenter
        };
        props.giftCardPayments(dataToGiftCardPayment).then((response) => {
          props.setAuthResponse(response).then(() => {
            setGiftBalance(0);
            setTipAmount(calTipAmt);
            const tips = JSON.parse(window.sessionStorage.getItem('tipAmt'));
            const updatesTips = {
              ...tips,
              unpaidTips: +(tips?.unpaidTips - calTipAmt) < 0 ? 0 : +(tips?.unpaidTips - calTipAmt),
              paidTips: +(tips?.paidTips + calTipAmt)
            };
            window.sessionStorage.setItem('tipAmt', JSON.stringify(updatesTips));
            setPaymentType(5);
          });
        }).catch((err) => {
          props.setNotification({
            type: 'danger',
            message: err.message
          });
        });
      }).catch((err) => {
        props.setNotification({
          type: 'danger',
          message: err.message
        });
      });
    });
  };

  const handleGiftCancel = (type) => {
    setGiftBalance(false);
    if (type === 'cancel') {
      props.setPaymentCheck({ ...props.paymentCheck }).then(() => {
        props.history.replace(({ pathname: `${APP_CONFIG.BASE_URL}/paymentTerminal/receipt/${props.paymentCheck.id}?ticketSplitTypeId=2&splitValue=1&screenType=2&&type=payType` }));
      });
    } else if (type === true) {
      props.clearGiftCardBalanceInfo();
    }
  };

  const creditCardPayment = (updatedData, count) => {
    props.setPaymentCheck(updatedData).then(() => {
      if (props.deviceInfo.deviceGroup && props.deviceInfo.deviceGroup.brandTipId) {
        props.history.replace(({ pathname: `${APP_CONFIG.BASE_URL}/paymentTerminal/receipt/${updatedData.id}?ticketSplitTypeId=3&splitValue=${count}&screenType=4` }));
      } else {
        props.history.replace(({ pathname: `${APP_CONFIG.BASE_URL}/paymentTerminal/receipt/${updatedData.id}?ticketSplitTypeId=3&splitValue=${count}` }));
        returnCreditCardMethod();
      }
    });
  };

  const paymentRouteForSplit = (key, updatedData, count) => {
    switch (key) {
      case 'creditCard': creditCardPayment(updatedData, count); break;
      case 'cash': handleCashPayment(); break;
      case 'scanToPay': break;
      default: creditCardPayment(updatedData, count); break;
    }
  };

  const handleSplitEvenly = (count) => {
    const splitAmount = isTableTop ? +(props.seat.totalAmount / count).toFixed(2) : +(props.paymentCheck.totalAmount / count).toFixed(2);
    const subTotalAmount = +((splitAmount * props.paymentCheck.itemAmount) / props.paymentCheck.totalAmount);
    const taxAmount = +((splitAmount * props.paymentCheck.taxAmount) / props.paymentCheck.totalAmount);
    const serviceCharge = props.paymentCheck.serviceChargeAmount > 0 ? +((splitAmount * props.paymentCheck.serviceChargeAmount) / props.paymentCheck.totalAmount) : 0;
    const discountAmount = props.paymentCheck.discountAmount > 0 ? +((splitAmount * props.paymentCheck.discountAmount) / props.paymentCheck.totalAmount) : 0;
    if (props.seat.tickets.length > 0 && [...props.seat.tickets].filter((d) => d.ticketStatusId === 1).length > 0 && [...props.seat.tickets].filter((d) => d.ticketStatusId === 1).length === getObjectValue(() => props.seat.tickets[0].splitValue - 1, 0)) {
      handlePayAnAmount({ payAnAmount: +((subTotalAmount + taxAmount + serviceCharge) - discountAmount - props.paymentCheck.paidAmount) / count });
    } else {
      const updatedData = {
        ...props.seat,
        subTotalAmount,
        unpaidAmount: ((subTotalAmount + taxAmount + serviceCharge) - discountAmount),
        taxAmount,
        paidAmount: 0,
        tipAmount: 0,
        totalAmount: ((subTotalAmount + taxAmount + serviceCharge) - discountAmount),
        serviceChargeAmount: serviceCharge,
        discountAmount
      };
      if (isTableTop && paymentBtn().key !== 'all') {
        setTableData(updatedData);
        paymentRouteForSplit(paymentBtn().key, updatedData, count);
      } else {
        props.setPaymentCheck(updatedData).then(() => {
          props.history.replace(({ pathname: `${APP_CONFIG.BASE_URL}/paymentTerminal/receipt/${updatedData.id}?ticketSplitTypeId=3&splitValue=${count}&screenType=2&type=payType` }));
        });
      }
    }
  };

  const handleKeyboardValue = (data) => {
    setKeyboardValue(data);
  };
  const handleConfirmSplit = () => {
    setIsConfirmSplit(false);
    if (splitType === 'split') {
      props.history.replace(({ pathname: `${APP_CONFIG.BASE_URL}/paymentTerminal/receipt/${tableData.id}?ticketSplitTypeId=3&splitValue=1&screenType=9&type=split` }));
      setPaymentType(9);
    } else {
      props.history.replace(({ pathname: `${APP_CONFIG.BASE_URL}/paymentTerminal/receipt/${tableData.id}?ticketSplitTypeId=2&splitValue=1&screenType=10&type=payAnAmount` }));
      setPaymentType(10);
    }
  };

  const openMOdel = () => {
    if (isPaymentTerminal && (props.auth?.loyaltyInfo?.suppressOfferOnSplitByPerson && false) && props.seat.discountAmount === 0) {
      setIsConfirmSplit(true);
      setSplitType('split');
    } else {
      props.history.replace(({ pathname: `${APP_CONFIG.BASE_URL}/paymentTerminal/receipt/${tableData.id}?ticketSplitTypeId=3&splitValue=1&screenType=9&type=split` })); setPaymentType(9);
    }
  };

  let splitEvently = {
    name: LABEL().SPLIT_EVENLY,
    click: () => { openMOdel(); },
    disabled: (isTableTop && (paymentBtn().key === 'cash' || paymentBtn().key === 'scanToPay')) || !isDefaultMode || ((props.auth.serverAppFeatures.supportsDeliveryOrders && props.auth.country === 4) || props.paymentCheck.totalAmount === 0)
  };
  const payFullCheck = {
    name: props.seat.paidAmount === 0 ? LABEL().PAY_FULL_CHECK : tableData.unpaidTips ? LABEL().PAY_REMAINING_BALANCE + ' ($' + (Number(tableData.unpaidAmount) + Number(tableData.unpaidTips)).toFixed(2) + ')' : LABEL().PAY_REMAINING_BALANCE + ' ($' + (Number(tableData.unpaidAmount)).toFixed(2) + ')',
    click: () => onPayFullCheckHandler(),
    disabled: (isTableTop && (paymentBtn().key === 'cash' || paymentBtn().key === 'scanToPay')) || false
  };
  let payByAmount = {
    name: LABEL().PAY_AN_AMOUNT,
    click: () => { props.history.replace(({ pathname: `${APP_CONFIG.BASE_URL}/paymentTerminal/receipt/${tableData.id}?ticketSplitTypeId=2&splitValue=1&screenType=10&type=payAnAmount` })); setPaymentType(10); },
    disabled: ((isTableTop && (paymentBtn().key === 'cash' || paymentBtn().key === 'scanToPay')) || !isDefaultMode || ((props.auth.serverAppFeatures.supportsDeliveryOrders && props.auth.country === 4) || props.paymentCheck.totalAmount === 0))
  };
  if ((props.deviceInfo?.deviceGroup?.splitTypes?.payAmount === false) || (Number(urlSearchParams('ticketSplitTypeId')) === 3) || (props.seat.paidAmount > 0 && Number(urlSearchParams('ticketSplitTypeId')) === 1)) {
    payByAmount = null;
  }
  const splitCheckNum = props.seat.paidAmount > 0 && props.seat.tickets && props.seat.tickets.length > 0 ? props.seat.tickets[0].splitValue - 1 : 0;
  const isSplitAllowed = getObjectValue(() => props.seat.paidAmount > 0 && Number(props.seat.tickets.length) < Number(splitCheckNum), false);
  if (isSplitAllowed) {
    splitEvently.name = `${LABEL().SPLIT_BY} 1/${props.seat.tickets[0] && props.seat.tickets[0].splitValue}`;
    splitEvently.click = () => handleSplitEvenly(props.seat.tickets[0] && props.seat.tickets[0].splitValue);
    payByAmount = null;
  } else if (props.seat.paidAmount > 0 && props.seat.tickets[0] && props.seat.tickets[0].splitValue > 1) {
    splitEvently = null;
  } else if (props.seat.paidAmount > 0) {
    splitEvently = null;
  }
  const PaymentPageBtn = [payFullCheck, countryCode === '1' ? splitEvently : null, countryCode === '1' ? payByAmount : null];
  const validatePayAnAmount = (value) => {
    const unpaidTips = tableData.unpaidTips || 0;
    const error = {};
    if (Number(value.payAnAmount) === 0 || Number.isNaN(value.payAnAmount) || value.payAnAmount === '.') {
      error.payAnAmount = 'Enter a amount more than 0 to pay';
    } else if (Number(value.payAnAmount) > Number(tableData.unpaidAmount + unpaidTips)) {
      error.payAnAmount = 'Enter amount less than total due amount';
    }
    return error;
  };

  const handleSurveySubmit = () => {
    setPaymentType(5);
  };

  const handleStopMagneticRead = () => {
    EventEmitter.stopMagneticCardRead((res) => {
    });
    EventEmitter.sendMessage({ type: 'stopMagCard' }, () => {
      console.log('success');
    },
      () => {
        console.log('failure');
      });
    setIsSwipe(false);
  };

  const activateIngenicoDevice = () => {
    try {
      EventEmitter.scanIngenicoDevice((res) => {
        handleGiftCard({ cardNumber: res, securityCode: null, method: 'swipe' });
        setGiftCardNumber(res);
        handleStopMagneticRead();
      },
        () => {
          handleStopMagneticRead();
        });
      EventEmitter.sendMessage({ type: 'scanMagCard' }, () => {
        console.log('success');
      },
        () => {
          console.log('failure');
        });
    } catch (e) {
      console.log('catch', e);
    }
  };

  const openCardPopUp = () => {
    setIsSwipe(true);
    activateIngenicoDevice();
  };

  const handleFailureRoute = (err) => {
    handleProcessCreditError(err.message);
  };

  const handleCountryCodeChange = (event) => {
    setPhoneNumberMaxLength(getObjectValue(() => COUNTRY_CODE[event.id].maxLength, 15));
    setCountryCode(event.id);
  };

  const handleRouteToCheckListing = () => {
    props.openEmployeeCheck();
  };
  const speedOrderRouteToChecks = () => {
    setCancelOrderConfirm(false);
    const dataToSend = {
      employeeId: Number(props.userInfo.id),
      storeId: props.deviceInfo.storeId,
      checkHeaderId: tableData.id,
      deviceId: props.deviceInfo.deviceId,
    };
    props.checkVoid(dataToSend).then((res) => {
      props.updateChecksAfterResponse(res);
      props.history.replace({
        pathname: `${APP_CONFIG.BASE_URL}/${flowType()}/checks`,
      });
    }).catch((e) => {
      props.setNotification({
        type: 'danger',
        message: e.message
      });
    });
  };

  const lockCallBack = () => {
    if (isCashPaymentCheck && !directToCashConfirm) {
      setIsCashPaymentCheck(false);
      setPaymentType(16);
      props.history.replace({ pathname: `${APP_CONFIG.BASE_URL}/${flowType()}/receipt/${props.paymentCheck.id}?ticketSplitTypeId=${urlSearchParams('ticketSplitTypeId')}&splitValue=${urlSearchParams('splitValue')}&screenType=16&type=${urlSearchParams('type')}` });
    } else if (directToCashConfirm) {
      handleCashPayment();
    } else {
      props.history.replace(`${APP_CONFIG.BASE_URL}/${flowType()}/checks`);
    }
  };

  const handleRouteToOrders = () => {
    const authResponse = getObjectValue(() => JSON.parse(window.sessionStorage.getItem('authResponse')), false);
    if (authResponse) {
      props.updateSeatInfo(authResponse.checkHeader);
      window.sessionStorage.removeItem('tipAmt');
      window.sessionStorage.removeItem('payAmt');
      props.history.replace(`${APP_CONFIG.BASE_URL}/${flowType()}/checks`);
    } else {
      props.history.replace(`${APP_CONFIG.BASE_URL}/orders`);
    }
  };
  const handelCustomTipModelClose = () => {
    const activeTip = getObjectValue(() => storeTips.find((item) => item.isDefault).key, '');
    setActive(activeTip);
    setCustomTipModelOpen(false);
  };
  return (
    <div className={cn('col-12 col-md-12 p-0 row mx-0 h-100 rowReverse')}>
      {props.loading && <Loader />}
      <div className="col-12">
        {(handleBackButton().isShow) && <div className="position-absolute text-primary od-text-primary" style={{ left: '-10px', top: '5px', zIndex: '999' }}><i role="presentation" className="fa fa-chevron-left fs-26" aria-hidden="true" onClick={() => handleBackButton().url()} /></div>}
        {!hideCancelIcon && (
          <div
            className="position-fixed text-right text-primary od-text-primary"
            style={{ right: '5px', top: 0, zIndex: '999' }}
          >
            {/* {!lockPaymentScreen ? (
              <i
                role="presentation"
                onClick={() => { return (isOrderPayMode || isKiosk || isCounter || isWalkUp) ? handleRouteToOrders() : handleRouteToCheckListing(); }}
                className="fa fa-times fs-18"
                aria-hidden="true"
              />
            ) : ( */}
            <i
              role="presentation"
              onClick={() => { return (isOrderPayMode || isKiosk || isCounter || isDriveThru || isWalkUp || isCallCenter) ? handleRouteToOrders() : handleRouteToCheckListing(); }}
              className="fa fa-lock fs-26"
              aria-hidden="true"
            />
            {/* )} */}
          </div>
        )}
      </div>
      <div className={cn('col-12 col-md-6 px-2', [3, 9, 10, 15, 17, 18, 2, 1].includes(paymentType) ? '' : isPaymentTerminal ? '' : '')}>
        <div className={cn('row mx-0', [4].includes(paymentType)  ? '' : '')}>
          <PaymentProcessScreen
            isCash={isTableTop ? (getObjectValue(() => props.deviceInfo.deviceGroup.paymentTypes.cash, false)) : supportCashPayment}
            isCreditCard={isTableTop ? (paymentBtn().key === 'creditCard' || (paymentBtn().key === 'all' && getObjectValue(() => props.deviceInfo.deviceGroup.paymentTypes.creditCard, false))) : countryCode !== '44'}
            sourceType={tableData.sourceType}
            setTextToPayModelOpen={setTextToPayModelOpen}
            tipAmount={tipAmount}
            paymentAmount={paymentAmount}
            totalAmount={tableData.totalAmount}
            paidAmount={tableData.paidAmount}
            unpaidAmount={props.authResponse ? getObjectValue(() => JSON.parse(window.sessionStorage.getItem('authResponse')).checkHeader.unpaidAmount, (props.authResponse && props.authResponse.checkHeader && props.authResponse.checkHeader.unpaidAmount)) : Number(props.seat.unpaidAmount)}
            paymentType={paymentType}
            loading={props.loading}
            loaded={props.loaded}
            error={props.error}
            currenySymbol={currenySymbol}
            handleButtonClick={handleButtonClick}
            setPaymentType={setPaymentType}
            handleRouteCheck={handleRouteCheck}
            handleTipsRouteTo={handleTipsRouteTo}
            tipsList={tipsList}
            handlePrint={handlePrint}
            active={active}
            charityList={charityList}
            handleCheck={handleCheck}
            logo={props.auth.logoImageUrl}
            paymentCallBack={completeProcessSale}
            handleReceiptPopUpOpen={handleReceiptPopUpOpen}
            handleRetry={handleRetry}
            PaymentPageBtn={PaymentPageBtn}
            isGiftCard={isTableTop ? false : (props.auth.loyaltyInfo.supportsGiftCardPayment && (!isCounter || !isDriveThru || !isCallCenter))}
            isSecurityCode={props.auth.loyaltyInfo.validateGiftCardSecurityCode}
            charity={props.auth.charity}
            applyDonation={applyDonation}
            handleSplitEvenly={handleSplitEvenly}
            handlePayAnAmount={handlePayAnAmount}
            keyboardValue={keyboardValue}
            handleKeyboardValue={handleKeyboardValue}
            validatePayAnAmount={validatePayAnAmount}
            hideSignature={hideSignature}
            subTotalAmount={tableData.subTotalAmount}
            handleSurveySubmit={handleSurveySubmit}
            handleGiftCard={handleGiftCard}
            giftCardPayment={giftCardPayment}
            giftBalance={giftBalance}
            paymentFlowType={props.paymentFlowType}
            giftCardSupportsSwipe={getObjectValue(() => props.auth.loyaltyInfo.giftCardMethods && props.auth.loyaltyInfo.giftCardMethods.includes('swipe'), false)}
            openCardPopUp={openCardPopUp}
            giftCardNumber={giftCardNumber}
            handleFailureRoute={handleFailureRoute}
            errorMessage={errorMessage}
            handleProcessCreditError={handleProcessCreditError}
            totalAmountForTip={getTotalAmountForTip()}
            handleGiftCancel={handleGiftCancel}
            isQrScan={isTableTop ? getObjectValue(() => props.deviceInfo.deviceGroup.paymentTypes.scanToPay, false) : false}
            isKiosk={isKiosk}
            isTableTop={isTableTop}
            isServerApp={isServerApp}
            supportsTips={supportsTips}
            tableData={{ ...tableData }}
            successMessage={successMessage}
            authResponse={getObjectValue(() => JSON.parse(window.sessionStorage.getItem('authResponse')), null)}
            handleBackButton={handleBackButton}
            isPaymentTerminal={isPaymentTerminal}
            handleCreditCard={handleCreditCard}
            deviceInfo={props.deviceInfo}
            handleDirectToCashConfirmation={handleDirectToCashConfirmation}
            receiptTypes={receiptTypes}
            isCounter={isCounter}
            handleHideCancelIcon={(status) => setHideCancelIcon(status)}
            isExternalCreditCard={isExternalCreditCard}
            isDriveThru={isDriveThru}
            isCallCenter={isCallCenter}
          />
        </div>
      </div>
      {![4, 5, 6, 9, 10, 11, 12, 15, 16].includes(paymentType) && (
        <div className="col-12 col-md-6 px-2 pt-10 h-60">
          <div className="row h-100 pt-4 mx-0">
            <ReceiptScreen
              tableData={{ ...tableData }}
              currenySymbol={currenySymbol}
              renderModifier={renderModifier}
              paymentType={paymentType}
              tipAmount={tipAmount}
              paymentAmount={paymentAmount}
              active={active}
              handleButtonClick={handleButtonClick}
              charityAmount={charityAmount}
              charityList={charityList.map((e) => e.displayKey)}
              keyboardValue={keyboardValue}
              handleKeyboardValue={handleKeyboardValue}
              paymentFlowType={props.paymentFlowType}
              unpaidTips={tableData.unpaidTips}
              paidTips={tableData.paidTips}
              countryCode={countryCode}
              successMessage={successMessage}
              charity={props.auth.charity}
              authResponse={getObjectValue(() => JSON.parse(window.sessionStorage.getItem('authResponse')), null)}
              supportsTips={supportsTips}
              isPaymentTerminal={isPaymentTerminal}
              paymentCheck={props.paymentCheck}
              deviceInfo={props.deviceInfo}
            />
          </div>
        </div>
      )}
      <div className={cn('col-12 col-md-6 px-2 py-4', [3, 9, 10, 15, 17, 18, 2, 1].includes(paymentType) ? 'h-60' : isPaymentTerminal ? 'h-100' : 'h-60')}>
        <div className={cn('row mx-0', [4].includes(paymentType) ? isPaymentTerminal ? 'h-100' : 'h-60' : 'h-100')}>
          <PaymentScreen
            isCash={isTableTop ? (getObjectValue(() => props.deviceInfo.deviceGroup.paymentTypes.cash, false)) : supportCashPayment}
            isCreditCard={isTableTop ? (paymentBtn().key === 'creditCard' || (paymentBtn().key === 'all' && getObjectValue(() => props.deviceInfo.deviceGroup.paymentTypes.creditCard, false))) : countryCode !== '44'}
            sourceType={tableData.sourceType}
            setTextToPayModelOpen={setTextToPayModelOpen}
            tipAmount={tipAmount}
            paymentAmount={paymentAmount}
            totalAmount={tableData.totalAmount}
            paidAmount={tableData.paidAmount}
            unpaidAmount={props.authResponse ? getObjectValue(() => JSON.parse(window.sessionStorage.getItem('authResponse')).checkHeader.unpaidAmount, (props.authResponse && props.authResponse.checkHeader && props.authResponse.checkHeader.unpaidAmount)) : Number(props.seat.unpaidAmount)}
            paymentType={paymentType}
            loading={props.loading}
            loaded={props.loaded}
            error={props.error}
            currenySymbol={currenySymbol}
            handleButtonClick={handleButtonClick}
            setPaymentType={setPaymentType}
            handleRouteCheck={handleRouteCheck}
            handleTipsRouteTo={handleTipsRouteTo}
            tipsList={tipsList}
            handlePrint={handlePrint}
            active={active}
            charityList={charityList}
            handleCheck={handleCheck}
            logo={props.auth.logoImageUrl}
            paymentCallBack={completeProcessSale}
            handleReceiptPopUpOpen={handleReceiptPopUpOpen}
            handleRetry={handleRetry}
            PaymentPageBtn={PaymentPageBtn}
            isGiftCard={isTableTop ? false : (props.auth.loyaltyInfo.supportsGiftCardPayment && (!isCounter || !isDriveThru || !isCallCenter))}
            isSecurityCode={props.auth.loyaltyInfo.validateGiftCardSecurityCode}
            charity={props.auth.charity}
            applyDonation={applyDonation}
            handleSplitEvenly={handleSplitEvenly}
            handlePayAnAmount={handlePayAnAmount}
            keyboardValue={keyboardValue}
            handleKeyboardValue={handleKeyboardValue}
            validatePayAnAmount={validatePayAnAmount}
            hideSignature={hideSignature}
            subTotalAmount={tableData.subTotalAmount}
            handleSurveySubmit={handleSurveySubmit}
            handleGiftCard={handleGiftCard}
            giftCardPayment={giftCardPayment}
            giftBalance={giftBalance}
            paymentFlowType={props.paymentFlowType}
            giftCardSupportsSwipe={getObjectValue(() => props.auth.loyaltyInfo.giftCardMethods && props.auth.loyaltyInfo.giftCardMethods.includes('swipe'), false)}
            openCardPopUp={openCardPopUp}
            giftCardNumber={giftCardNumber}
            handleFailureRoute={handleFailureRoute}
            errorMessage={errorMessage}
            handleProcessCreditError={handleProcessCreditError}
            totalAmountForTip={getTotalAmountForTip()}
            handleGiftCancel={handleGiftCancel}
            isQrScan={isTableTop ? getObjectValue(() => props.deviceInfo.deviceGroup.paymentTypes.scanToPay, false) : false}
            isKiosk={isKiosk}
            isTableTop={isTableTop}
            isServerApp={isServerApp}
            supportsTips={supportsTips}
            tableData={{ ...tableData }}
            successMessage={successMessage}
            authResponse={getObjectValue(() => JSON.parse(window.sessionStorage.getItem('authResponse')), null)}
            handleBackButton={handleBackButton}
            isPaymentTerminal={isPaymentTerminal}
            handleCreditCard={handleCreditCard}
            deviceInfo={props.deviceInfo}
            handleDirectToCashConfirmation={handleDirectToCashConfirmation}
            receiptTypes={receiptTypes}
            isCounter={isCounter}
            handleHideCancelIcon={(status) => setHideCancelIcon(status)}
            isExternalCreditCard={isExternalCreditCard}
            isDriveThru={isDriveThru}
            isCallCenter={isCallCenter}
          />
        </div>
      </div>
      {isCashPaymentCheck && (
        <CashPaymentCheckPopUp
          isOpen={isCashPaymentCheck}
          onClose={() => setIsCashPaymentCheck(false)}
          cashPaymentCheck={cashPaymentCheck}
          auth={props.auth}
          isPaymentTerminal={isPaymentTerminal}
        />
      )}
      {props.isEmployeeCheck && <EmployeeCheck {...props} callBack={lockCallBack} caseType={isCashPaymentCheck ? 'cashCheck' : flowType()} />}
      <ReceiptScreenPopUp
        onClose={() => setIsReceipt({ isOpen: false, type: '' })}
        isOpen={isReceipt.isOpen}
        type={isReceipt.type}
        handleReceipt={handleReceipt}
        countryCode={countryCode}
        phoneNumberMaxLength={phoneNumberMaxLength}
        handleCountryCodeChange={handleCountryCodeChange}
        isCounter = {isCounter}
        isDriveThru={isDriveThru}
        isCallCenter={isCallCenter}
      />
      {isTipsConfirm && (
        <TipsConfirmPopUp
          isOpen={isTipsConfirm}
          supportsWarnOnUnusualTip={supportsWarnOnUnusualTip}
          onClose={() => setIsTipsConfirm(false)}
          onSubmitTips={() => handleTipsSubmit()}
          tipAmount={tipAmount}
          totalAmount={tableData.subTotalAmount.toFixed(2)}
        />
      )}
      <Modal
        isOpen={props.isPrintOpen}
        isModalCenter
      >
        <div className="col-12 my-2 justify-content-center align-items-center position-relative text-center od-text-primary text-primary">
          {/* <div className="p-1 position-absolute" style={{ right: '5px', top: '0px' }}>
              <div className="" role="presentation" onClick={() => { props.closeModal(); }}>
                <i className="fa fa-times" aria-hidden="true" />
              </div>
            </div> */}
          <div>
            <div className="text-left">Printer IP Address :{props.printData.printerIpAddress}</div><br />
            <div className="text-left">Printer Name: {props.printData.printerName}</div><br />
            <div className="text-left">Printer Port: {props.printData.printerPort} </div>
          </div>
          <div className={cn(style.imgSpin, 'od-spinner position-absolute')} />
        </div>
      </Modal>
      <Modal
        isOpen={confirmCashPayment}
        isModalCenter
      >
        <div className="col-12 my-2 justify-content-center align-items-center position-relative text-center od-text-primary text-primary">
          {/* <div className="p-1 position-absolute" style={{ right: '5px', top: '0px' }}>
            <div className="" role="presentation" onClick={() => setConfirmCashPayment(false)}>
              <i className="fa fa-times" aria-hidden="true" />
            </div>
          </div> */}
          <div className="px-2 text-right">
            <i
              role="presentation"
              onClick={() => setConfirmCashPayment(false)}
              className="fa fa-times fs-18"
              aria-hidden="true"
            />
          </div>
          <div className="col-12 fs-18 mt-10 fw-700 text-center">
            <div className="fs-20">{CUSTOM_MESSAGES().PROCEED_WITH_CASH_PAYMENT_OF} {currenySymbol}{tableData && Number(tableData.totalAmount - tableData.paidAmount).toFixed(2)}?</div>
          </div>
          <div className="col-12 d-flex justify-content-center">
            <button type="submit" className="col-4 m-2 btn btn-secondary od-btn-secondary" onClick={() => setConfirmCashPayment(false)}>
              <div className="fs-18">{LABEL().NO}</div>
            </button>
            <button type="submit" className="col-4 m-2 btn btn-primary btn-ripple btn-lg od-btn-primary" onClick={() => { handleCashPayment(); }}>
              <div className="fs-18">{LABEL().YES}</div>
            </button>
          </div>
        </div>
      </Modal>
      <Modal isOpen={isSwipe} isModalCenter>
        <div className="row mb-0">
          <div className="col-12 mt-20 mb-20 justify-content-center align-items-center text-center">
            {CUSTOM_MESSAGES().SWIPE_CARD_AFTER_BEEP}
          </div>
          <div className="col-12 mt-20 mb-20 justify-content-center align-items-center text-center">
            <button className="btn btn-secondary od-btn-secondary" type="button" onClick={() => { handleStopMagneticRead(); }}>
              {LABEL().CANCEL}
            </button>
          </div>
        </div>
      </Modal>
      <Modal
        isOpen={textToPayModelOpen}
        isModalCenter
      >
        <div className="col-12 my-2 justify-content-center align-items-center position-relative text-center od-text-primary text-primary">
          <div className="p-1 position-absolute" style={{ right: '5px', top: '0px' }}>
            <div className="" role="presentation" onClick={() => { setTextToPayModelOpen(false); }}>
              <i className="fa fa-times" aria-hidden="true" />
            </div>
          </div>
          <div className="col-12 fs-18 mt-10 fw-700 text-center">
            <div className="fs-18 od-text-primary">This will send a text to pay link to phone number {getObjectValue(() => props.seat.orders[0].phoneNumber, '')}. Do you want to continue? </div>
          </div>
          <div className="col-12 d-flex justify-content-center">
            <button type="submit" className="col-4 m-2 btn btn-secondary od-btn-secondary" onClick={() => setTextToPayModelOpen(false)}>
              <div className="fs-18">{LABEL().NO}</div>
            </button>
            <button type="submit" className="col-4 m-2 btn btn-primary btn-ripple btn-lg od-btn-primary" onClick={() => { handleCheck('textToPay'); setTextToPayModelOpen(false); }}>
              <div className="fs-18">{LABEL().YES}</div>
            </button>
          </div>
        </div>
      </Modal>
      {confirmPopup && (
        <Modal
          isOpen={confirmPopup}
          isModalCenter
        >
          <div className="col-12 my-2 px-0 justify-content-center align-items-center position-relative text-center od-text-primary text-primary">
            <div className="px-2 text-right fs-18">
              <i
                onClick={() => { setConfirmPopup(false); }}
                role="presentation"
                className="fa fa-times"
                aria-hidden="true"
              />
            </div>
            <div className="col-12 fs-18 fw-700 text-center">
              {returnCustomMessageWithReplace()}
            </div>
            <div className="col-12 d-flex justify-content-center">
              <button type="submit" className="col-4 m-2 btn btn-secondary od-btn-secondary" onClick={() => { setConfirmPopup(false); setTipAmount(0); }}>
                <div className="fs-18">{LABEL().NO}</div>
              </button>
              <button type="submit" className="col-4 m-2 btn btn-primary btn-ripple btn-lg od-btn-primary" onClick={() => { setConfirmPopup(false); handleCashPayment(); }}>
                <div className="fs-18">{LABEL().YES}</div>
              </button>
            </div>
          </div>
        </Modal>
      )}
      {cancelOrderConfirm && (
        <Modal
          isOpen={cancelOrderConfirm}
          isModalCenter
        >
          <div className="col-12 my-2 px-0 justify-content-center align-items-center position-relative text-center od-text-primary text-primary">
            <div className="px-2 text-right fs-18">
              <i
                onClick={() => { setCancelOrderConfirm(false); }}
                role="presentation"
                className="fa fa-times"
                aria-hidden="true"
              />
            </div>
            <div className="col-12 fs-18 fw-700 text-center">
              {CUSTOM_MESSAGES().CANCEL_ORDER}
            </div>
            <div className="col-12 d-flex justify-content-center">
              <button type="submit" className="col-4 m-2 btn btn-secondary od-btn-secondary" onClick={() => setCancelOrderConfirm(false)}>
                <div className="fs-18">{LABEL().NO}</div>
              </button>
              <button type="submit" className="col-4 m-2 btn btn-primary btn-ripple btn-lg od-btn-primary" onClick={() => { speedOrderRouteToChecks(); }}>
                <div className="fs-18">{LABEL().YES}</div>
              </button>
            </div>
          </div>
        </Modal>
      )}
      <Modal isOpen={isCustomTipModelOpen} isModalCenter>
        <div className="col-12 justify-content-center align-items-center position-relative text-center od-text-primary text-primary">
          <div className="p-1 position-absolute" style={{ right: '1px', top: '0px' }}>
            <div className="" role="presentation" onClick={() => { handelCustomTipModelClose(); }}>
              <i className="fa fa-times" aria-hidden="true" />
            </div>
          </div>
          <div className="col-12 w-100 mt-2">
            <div className={cn('col-10 m-auto fs-28 align-items-center text-center od-text-primary text-primary', style.divForPayment)}>{active === `Other ${LABEL().CURRENCY_SYMBOL}` ? CUSTOM_MESSAGES().ENTER_TIP_AMOUNT : CUSTOM_MESSAGES().ENTER_TIP_PERCENT}</div>
          </div>
          <div className={cn('col-12 text-center', style.padding5)}>
            <NumberKeyboard
              name="tipsAmount"
              haveCurrency={
                active === `Other ${LABEL().CURRENCY_SYMBOL}` ? `${LABEL().CURRENCY_SYMBOL}` : '%'
              }
              type="withoutDone"
              isOpen={isCustomTipModelOpen}
              placeholder="0"
              isDotRequired
              value={active === `${LABEL().ROUND_UP}` ? '' : keyboardValue}
              onChange={(e) => {
                handleKeyboardValue(e);
              }}
            />
            <button type="submit" className={cn('btn btn-primary btn-ripple od-btn-primary btn70 w-100 mt-10', style.divForPayment)} style={{ fontSize: '25px' }} onClick={() => handleCustomButtonClick(active, keyboardValue)}>{LABEL().CONTINUE}</button>
          </div>
        </div>
      </Modal>
      <Modal
        isOpen={isConfirmSplit}
        isModalCenter
      >
        <div className="col-12 my-2 px-0 justify-content-center align-items-center position-relative text-center od-text-primary text-primary">
          <div className="px-2 text-right fs-18">
            <i
              onClick={() => { setIsConfirmSplit(false); }}
              role="presentation"
              className="fa fa-times"
              aria-hidden="true"
            />
          </div>
          <div className="col-12 fs-18 fw-700 text-center">
            {CUSTOM_MESSAGES().CONFIRM_SPLIT}
          </div>
          <div className="col-12 d-flex justify-content-center">
            <button type="submit" className="col-4 m-2 btn btn-secondary od-btn-secondary" onClick={() => setIsConfirmSplit(false)}>
              <div className="fs-18">{LABEL().NO}</div>
            </button>
            <button type="submit" className="col-4 m-2 btn btn-primary btn-ripple btn-lg od-btn-primary" onClick={() => { handleConfirmSplit(); }}>
              <div className="fs-18">{LABEL().YES}</div>
            </button>
          </div>
        </div>
      </Modal>
    </div>
  );
};

const mapStateToProps = state => ({
  loading:
    state.payment.loading ||
    state.storeChecks.loading ||
    state.survey.loading ||
    state.orders.loading,

  deviceInfo: state.oauth.deviceInformation,
  userInfo: state.oauth.loggedInUserData,
  auth: state.oauth.authInfo,
  seat: state.orders.seats,
  paymentCheck: state.orders.paymentCheck,
  authResponse: state.payment.authResponse,
  isPrintOpen: state.notification.isPrintOpen,
  printData: state.notification.printData,
  surveyData: state.survey.surveyData,
  giftCard: state.payment.giftCard,
  isEmployeeCheck: state.oauth.isEmployeeCheck,
  cardReaderStatus: state.oauth.cardReaderStatus,
  employeeJobHashTable: state.oauth.employeeJobHashTable,
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
  paymentInitialization,
  giftCardBalance,
  clearGiftCardBalanceInfo,
  paymentCash,
  ingenicoLog,
  paymentAuth,
  paymentAuthError,
  setNotification,
  paymentAuthComplete,
  paymentSale,
  receiptSms,
  paymentSignature,
  setAuthResponse,
  receiptEmail,
  updateChecksAfterResponse,
  removeSeat,
  removePaymentCheck,
  receiptPrint,
  updateSeatInfo,
  setPaymentCheck,
  setPrintNotification,
  closePrintNotification,
  submitSurvey,
  textToPay,
  getSurvey,
  giftCardPaymentInit,
  giftCardPayments,
  openEmployeeCheck,
  callServer,
  clearAuthResponse,
  checkVoid,
  ingenicoPayment,
  setScreenSaverStatus
}, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PaymentTerminalReceiptScreen);
